// Shared helpers for the subscription / billing API.
// Every billing endpoint is Private: send the JWT in the x-auth-token header.

export const authHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'x-auth-token': localStorage.getItem('CloudForge-Token'),
  },
});

// The API returns failures as either { msg, code } (4xx) or { error } (500).
// parseApiError pulls out a user-facing message regardless of shape.
export const parseApiError = (requestError, fallback = 'Something went wrong.') =>
  requestError?.response?.data?.msg ||
  requestError?.response?.data?.error ||
  requestError?.message ||
  fallback;

// The backend error code (e.g. 'SUBSCRIPTION_REQUIRED'), when present.
export const apiErrorCode = (requestError) => requestError?.response?.data?.code || null;

export const apiStatus = (requestError) => requestError?.response?.status || null;
